@use '@design/design-tokens/typography/typography' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  @include typography-v2-title-lg;
  color: var(--text-default);
  margin: 20px 0 0 20px;
}

.content {
  @include custom-scroll-minimal;
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 12px;
}

.description {
  @include typography-v2-body-base;
}
